import { useState } from 'react';
import logo from '../../assets/imgs/logo.svg';
import CallToActionButton from './CallToActionButton';

const MenuList = ({ icons }) => {
  return (
    <ul>
      <li>
        <a href='/'>
          {icons && <i className='fas fa-home'></i>}
          Home
        </a>
      </li>
      <li>
        <a href='/about'>
          {icons && <i className='fas fa-info-circle'></i>}About
        </a>
      </li>
      <li>
        <a href='/drivers'>{icons && <i className='fas fa-car'></i>}Drivers</a>
      </li>
      <li>
        <a href='/privacy'>{icons && <i className='fas fa-lock'></i>}Privacy</a>
      </li>
      <li>
        <a href='/feedback'>
          {icons && <i className='fas fa-comments'></i>}Feedback
        </a>
      </li>
    </ul>
  );
};

export const Header = ({ action }) => {
  const [navActive, setNavActive] = useState(false);

  const openNavMenu = () => {
    document.querySelector('body').classList.add('zero-scroll');
    setNavActive(true);
  };

  const closeNavMenu = () => {
    document.querySelector('body').classList.remove('zero-scroll');
    setNavActive(false);
  };

  return (
    <div className='nav-header'>
      <img src={logo} alt='LionTaxi logo' width={100} height={100} />
      <div className='nav-content'>
        <MenuList icons={false} />
        <CallToActionButton title={'Get Started'} action={action} />
      </div>
      <div className='hamburger-menu' onClick={openNavMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className={`mobile-menu ${navActive ? 'active' : ''}`}>
        <div>
          <i className='far fa-times-circle' onClick={closeNavMenu}></i>
          <MenuList icons={true} />
          {/* <CallToActionButton title={'Get Started'} /> */}
        </div>
      </div>
    </div>
  );
};

Header.defaultProps = {
  action: '/download',
};
